import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { addFilterCategory, toggleCategoryCollapse} from "./../store/filters";
import Category from './../category-type/category';
import checkbox from './../category-type/checkboxCategory';
import range from './../category-type/rangeCategory';
import { selectFilteredProducts, getFilteredProducts } from '../store/products';

var types = {
    checkbox,
    range,
}

// dataPoint: the datapoint from products to be used as the filter
// type: the type of filter (currently supports checkbox or range)
// heading: the heading of the product category (also used as slider pill display name)
// orderByDirection: either 'asc' or 'desc'.  Default is asc.  Defines wether the order of the options are ascending or descending.
// checkboxOrderBy: for individual checkbox items (not collections).  Can define a seperate field name (int) that holds the order of the item.  
//          This helps define custom orders for non collection properties.
function FilterCategory(props) {
    // seperate UI bounds from from filter bounds in order for no re-render to occur on slide movement
    const products = useSelector(state => state.products.products);
    const filters = useSelector(state => state.filters.filters);
    const filteredProducts = useSelector(selectFilteredProducts);
    const fcState = useSelector(state => state.filters.filters[props.dataPoint]);
    const dispatch = useDispatch();
    const categoryId = props.dataPoint;
    const isSmallScreen = useSelector(state => state.app.smallScreen);

    // Build state
    React.useEffect(() => {
        let category = new Category(props.heading, props.dataPoint, props.checkboxOrderBy, props.orderByDirection, types[props.type], props.collapsed);
        category.buildOptions(products);
        if (props.step) category.addMeta('step', props.step);
        if (props.isAnd) category.addMeta('isAnd', props.isAnd);
        if (props.units) category.addMeta('units', props.units);
        dispatch(addFilterCategory(category, categoryId))
        // Ensure all filters are collapsed on mobile
        if (isSmallScreen && !category.collapsed) {
            dispatch(toggleCategoryCollapse(categoryId));
        }
    },[])

    // if component hasn't yet set a state, return null.
    if (!fcState) return null;

    // renderCategory is a transformed version of categories to include where an option is available or not.
    // the transformation only occurs if it is not the activeFilterCategory
    //
    // Range filters must use filtered products that do not include themselves as a filter. 
    // Below contains a work around although it is not very performant as it need to refilter all products for each range filter. There should be a efficient fix.
    let renderCategory = fcState;
    if (filteredProducts.length > 0) {
        if (fcState.type === "range" || !props.isAnd) {
            let nf = {...filters};
            delete nf[fcState.dataPoint];
            let nfp = getFilteredProducts(products, nf);
            renderCategory = fcState.hasProductsTransform(nfp);
        } else {
            renderCategory = fcState.hasProductsTransform(filteredProducts);
        }
    }

    return (
        <section className={`filterCategory ${fcState.collapsed ? "collapsed" : ""} ${fcState.type} ${renderCategory.activeOptionsList().length > 0 ? "active" : ""}`}>
            <button className={`filterCategoryHeader menuBtn`} onClick={(e) => {e.preventDefault(); dispatch(toggleCategoryCollapse(categoryId))}}>
                <h4>{props.heading}</h4>
                <div className={`expandSymbol ${fcState.collapsed ? "collapsed" : ""} dark`}></div>
            </button>
            {fcState.collapsed && renderCategory.activeOptionsList().length > 0 ? (
                <div className="optionIndicators">{renderCategory.activeOptionsList().map((op, index) => (<span className={"optionIndicator"} key={index}>{op}</span>))}</div>
                ) : ""}
            <div className={`options ${fcState.collapsed ? "collapsed" : ""}`}>
                {renderCategory.element()}
            </div>
        </section>
    )
}

export default FilterCategory;